import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AccountingService {
    private functionsUrl = environment.apiUrl.replace('/api/v1', '/functions/v1');

    constructor(private http: HttpClient) { }

    private invoke(functionName: string, action: string, data?: any, filters?: any): Observable<any> {
        return this.http.post(`${this.functionsUrl}/${functionName}`, { action, data, filters });
    }

    // Accounts
    getAccounts(): Observable<any[]> {
        return this.invoke('accounting-accounts', 'list');
    }

    createAccount(data: any): Observable<any> {
        return this.invoke('accounting-accounts', 'create', data);
    }

    updateAccount(id: string, data: any): Observable<any> {
        return this.invoke('accounting-accounts', 'update', data, { id });
    }

    // Categories
    getCategories(): Observable<any[]> {
        return this.invoke('accounting-categories', 'list');
    }

    // Transactions
    getTransactions(filters?: any): Observable<any[]> {
        return this.invoke('accounting-transactions', 'list', null, filters);
    }

    createTransaction(data: any): Observable<any> {
        return this.invoke('accounting-transactions', 'create', data);
    }

    // Contacts
    getContacts(): Observable<any[]> {
        return this.invoke('accounting-contacts', 'list');
    }

    // Reports
    getProfitLoss(startDate: string, endDate: string): Observable<any> {
        return this.invoke('accounting-reports', 'profit_loss', { startDate, endDate });
    }

    getCashSummary(asOfDate: string): Observable<any> {
        return this.invoke('accounting-reports', 'cash_summary', { asOfDate });
    }
}
